import React, { useEffect, useState } from "react";
import { dropdownService, notificationService } from "../../../services";
import { Button, Form, Input, Modal, notification, Select } from "antd";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";

const { TextArea } = Input

const sendNotification = async (userIds = []) => {
    await Promise.all(
        userIds.map(async (userId) => {
            const ref = doc(db, "notification_counts", String(userId));
            const snap = await getDoc(ref);

            if (snap.exists()) {
                const current = snap.data().count || 0;
                await updateDoc(ref, { count: current + 1 });
            } else {
                await setDoc(ref, { count: 1 });
            }
        })
    );
};


function ModalForm({ form, isAdmin, isModalOpen, handleCancel, setNotifications }) {

    // const [form] = Form.useForm();

    const [customers, setCustomers] = useState([])

    const handleSend = async () => {
        form
            .validateFields()
            .then(async (values) => {
                const response = await notificationService.add(values);
                if (response?.success ?? false) {
                    notification.success({
                        message: "Notification Sent"
                    })
                    sendNotification(values.recipients);

                    // Add the new notification to the list
                    const newNotification = {
                        id: response.data?.id ?? Date.now(),
                        subject: values.subject,
                        message: values.message,
                        is_read: null
                    };

                    setNotifications(prev => [newNotification, ...prev]);
                    handleCancel()
                }
            })
            .catch((info) => {
                console.log('Validation Failed:', info);
            });
    };

    const getCustomers = async () => {
        const { success, data } = await dropdownService.fetchCustomers();
        if (success) {
            setCustomers(data)
        }
    }

    useEffect(() => {
        if (isAdmin) getCustomers()
    }, [])

    return (
        <Modal
            // title="Send Message"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="Select Customer"
                    name="recipients"
                    rules={[{ required: true, message: 'Please select Customer ' }]}
                >
                    <Select placeholder="Enter Customer " mode="multiple" allowClear showSearch optionFilterProp="children">

                        {customers?.map((cust) => (
                            <Select.Option key={cust.id} value={cust.id}>{cust.name}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Subject"
                    name="subject"
                    rules={[{ required: true, message: 'Please Fill Subject' }]}
                >
                    <Input placeholder="Enter Subject" />
                </Form.Item>

                <Form.Item
                    label="Body"
                    name="message"
                    rules={[{ required: true, message: 'Please Fill Body' }]}
                >
                    <TextArea rows={4} placeholder="Type your message..." />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" onClick={handleSend} block>
                        Send
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModalForm;